module.exports = __webpack_public_path__ + "img/723-efaf49.png";